import { useTranslation } from 'react-i18next';
import React, { useState, useEffect } from 'react'
import { Badge, Upload, Button, Image, Form, Input, message, Modal } from 'antd'
import { CloseCircleOutlined } from '@ant-design/icons'
import { fileUploadUrl, fileLookUrl } from '@/config/app'
import { getToken } from '@/utils/dataStorage'
import FontIcon from '@/erp_subpackage/components/YhIcon'
import { UploadOutlined } from '@ant-design/icons'

export const __FormUploads = ({ md5List = [], onSetFieldsValue, ...props }) => {
    const {t} = useTranslation()
    const onPreview = (file) => {
        const { md5 } = file
        const type = md5.split('.')[1]
        if (['jpg', 'png', 'jpeg', 'gif'].includes(type)) {
            Modal.info({
                title: t(`erpcomponents.item.FormUploads.图片查看`),
                content: <img style={{ width: '100%' }} src={`${fileLookUrl().image}${md5}`} />,
                okText: t(`erpcomponents.item.FormUploads.确定`),
                cancelText: t(`erpcomponents.item.FormUploads.取消`),
                centered: true,
                width: 800,
            })
        } else {
            window.open(`${fileLookUrl().image}${md5}`)
            // fileDownload(getBaseImgLookUrl(uid), name)
        }
    }

    const [data, setdata] = useState(md5List) //商品缩略图 string[]

    useEffect(() => {
        setdata(md5List)
    }, [ md5List ])

    useEffect(() => {
       
        onSetFieldsValue && onSetFieldsValue({ [props.fieldName]: data})
    }, [data])

    /*上传图片成功后的回掉 */
    const upLoadCallback = async (file) => {
        try {
            let md5 = file.response.retData
            setdata((origin) => [...origin, { md5 }])
        } catch {}
    }

    return (
        <>
            <Form.Item name={props.fieldName} hidden>
                <Input />
            </Form.Item>
            <Form.Item name={props.fieldMd5} label={props.fieldLabel} rules={props.rules} labelCol={props.labelCol}>
                {data &&
                    data.map((item, index) => (
                        <div key={index} style={{ float: 'left', marginRight: '10px' }}>
                            <Badge
                                count={
                                    props.disable ? null : (
                                        <CloseCircleOutlined
                                            style={{ color: '#f5222d' }}
                                            onClick={(e) => {
                                                e.stopPropagation()
                                                let originImg = data.filter((imgMd5) => imgMd5.md5 !== item.md5)
                                                setdata(originImg)
                                            }}
                                        />
                                    )
                                }
                            >
                                <FontIcon
                                    onClick={() => {
                                        onPreview(item)
                                    }}
                                    style={{ fontSize: '48px' }}
                                    type="icon-tupian"
                                />
                            </Badge>
                        </div>
                    ))}
                {!props.disable && (
                    <Upload
                        showUploadList={false}
                        beforeUpload={(file ) => {
                            // let fileEnd = file.name?.substring(file.name.lastIndexOf('.')) ?? ''
                            // let filetypes = ['.jpg', '.jpeg', '.png', '.gif', '.svg']
                            // let isType = filetypes?.includes(fileEnd)
                            // if (!isType) {
                            //     message.error('不支持该格式的上传')
                            //     return false
                            // }
                            // const isLt2M = file.size / 1024 / 1024 < 2
                            // if (!isLt2M) {
                            //     message.error('上传到文件不能超过2M')
                            //     return false
                            // }
                            // return true
                        }}
                        {...{
                            name: 'file',
                            action: `${fileUploadUrl}upload/image_old`,
                            headers: { authorization: getToken() },
                            timeout: 300000,
                            onChange(info) {
                                try {
                                    if (info.file.status === 'done' && info.file.response && info?.file?.response?.retData) {
                                        message.info({
                                            content: t(`erpcomponents.item.FormUploads.导入成功`),
                                            duration: 10,
                                        })
                                        upLoadCallback(info.file)
                                    } else if (info.file.status === 'error' && info.file.response) {
                                        message.error(`${info.file.name}:${info.file.response.message}${t(`erpcomponents.item.FormUploads.导入异常，请尝试重新导入`)}`)
                                        upLoadCallback(undefined)
                                    } else if (info.file.status === 'error') {
                                        message.error(t(`erpcomponents.item.FormUploads.导入错误`))
                                        upLoadCallback(undefined)
                                    } else if (!info.file.status) {
                                        upLoadCallback(undefined)
                                    }
                                } catch (error) {
                                    message.warning(t(`erpcomponents.item.FormUploads.导出异常，请重新尝试`))
                                    upLoadCallback(undefined)
                                }
                            },
                        }}
                    >
                        
                            <Button className="btn-item" shape="round" disabled={props.disable}>
                                
                                {t(`erpcomponents.item.FormUploads.上传`)}
                            </Button>
                       
                    </Upload>
                )}
            </Form.Item>
        </>
    )
}
